export default "__VITE_ASSET__DkPw5jLW__"